<template>
  <b-row class="palestra">
    <b-col
      class="foto"
      @click="assistirAoVivo"
      :style="palestra.isAoVivo ? 'cursor:pointer;' : ''"
    >
      <b-img
        :src="`${baseUrl}${palestra.photo}`"
        fluid
        class="d-inline-block imagem"
        alt="imagem do palestrante"
      />
    </b-col>
    <b-col class="conteudo">
      <div
        class="informacoes"
        @click="assistirAoVivo"
        :style="palestra.isAoVivo ? 'cursor:pointer;' : ''"
      >
        <div class="titulo">{{ palestra.title }}</div>
      </div>
      <div
        class="nome"
        @click="assistirAoVivo"
        :style="palestra.isAoVivo ? 'cursor:pointer;' : ''"
      >
        {{ palestra.speaker.name }}
      </div>
      <span v-if="palestra.description.length < 60">{{
        palestra.description
      }}</span>
      <div id="hide">
        <div v-show="!seen">
          <div v-if="palestra.description.length >= 60">
            <span>{{ palestra.description.slice(0, 60) + "... " }}</span>
            <b @click="seen ^= true">
              <u style="cursor: pointer">Saiba mais</u>
            </b>
          </div>
        </div>
        <div v-show="seen">
          <span>
            {{ palestra.description }}
            <b @click="seen ^= true">
              <u style="cursor: pointer">Mostrar menos</u>
            </b>
          </span>
        </div>
      </div>
    </b-col>
    <b-col class="painel">
      <div
        v-if="palestra.isAoVivo"
        class="estado mb-2"
        @click="assistirAoVivo"
        :style="palestra.isAoVivo ? 'cursor:pointer;' : ''"
      >
        <span>Ao vivo</span>
        <b-img
          :src="require('@/assets/Palestras/electronics.png')"
          class="d-inline-block"
          fluid
        />
      </div>
      <div
        class="horario"
        @click="assistirAoVivo"
        :style="palestra.isAoVivo ? 'cursor:pointer;' : ''"
      >
        Horário:
        {{ `${palestra.hour.split(":")[0]}:${palestra.hour.split(":")[1]}` }}
      </div>
      <div class="buttons">
        <ButtonFill
          v-if="palestra.isInscrito || isInscrito"
          @click="cancelarInscricao()"
          texto="Cancelar Inscrição"
          :disabled="palestraPassada"
        />
        <ButtonFill
          v-else
          @click="inscreverUsuario()"
          :disabled="palestraPassada"
          texto="Inscreva-se"
        />
      </div>
    </b-col>
  </b-row>
</template>

<script>
import ButtonFill from "@/components/Button-fill.vue";
import { baseUrl } from "@/config/constants";

export default {
  components: {
    ButtonFill,
  },
  data() {
    return {
      seen: false,
      palestraPassada: false,
    };
  },
  computed: {
    baseUrl() {
      return baseUrl;
    },
  },
  methods: {
    assistirAoVivo() {
      if (this.palestra.isAoVivo) {
        this.$router.push("/ao-vivo");
      }
    },
    inscreverUsuario() {
      this.$emit("inscreverUsuario");
    },
    cancelarInscricao() {
      this.$emit("cancelarInscricao");
    },
    toast(titleShow, toaster, textShow, append = false) {
      this.$bvToast.toast(textShow, {
        title: titleShow,
        toaster: toaster,
        solid: true,
        appendToast: append,
      });
    },
    verificaData() {
      let dataAtual = new Date();
      let diaPalestra = this.palestra.date.split("-");
      let horarioPalestra = this.palestra.hourEnding.split(":");
      let dataPalestra = new Date(
        diaPalestra[0],
        diaPalestra[1] - 1,
        diaPalestra[2],
        horarioPalestra[0],
        horarioPalestra[1],
        horarioPalestra[2]
      );
      this.palestraPassada = dataAtual > dataPalestra;
    },
  },
  props: {
    isInscrito: {
      type: Boolean,
      default: false,
    },
    palestra: {
      type: Object,
      required: true,
    },
  },
  updated() {
    this.verificaData();
  },
  created() {
    this.verificaData();
  },
};
</script>

<style lang="scss" scoped>
.btn-light {
  color: #7e7e7e;
}
.btn-light:hover {
  color: #f0f0f0;
  background-color: #7e7e7e;
}
.horario {
  font-size: 1.1rem !important;
  margin-bottom: 10px;
}
.buttons {
  display: flex;
  flex-direction: column;
}

// .imagem {
//   width: 200px;
//   max-width: 200px;
//   height: 200px;
//   object-fit: cover;
// }
.palestra {
  width: 80%;
  height: auto;
  border: 1px solid;
  border-image: linear-gradient(to right, #2b195d, #d640f4) 1;
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  text-align: left;
  .foto {
    padding: 20px;
    .imagem {
      width: 200px;
      max-width: 200px;
      max-height: 200px;
      height: 200px;
      object-fit: cover;
    }
  }

  .estado {
    color: #ff1601;
    font-size: 1.5rem;
    img {
      width: 20px;
      height: auto;
      margin-left: 5px;
      animation: neon 1s alternate infinite ease-in-out;
      --cor-neon: #ff1601;
    }
  }
  .conteudo {
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 4;
    padding-top: 30px;
    padding-bottom: 10px;
    .informacoes {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .titulo {
        font-size: 2rem;
        font-weight: 600;
      }
    }
    .nome {
      font-size: 2rem;
      font-weight: 200;
      text-align: left !important;
    }
    .resumo {
      align-content: left;
      font-size: 1rem;
      font-weight: 400;
      text-align: justify;
    }
  }
  .painel {
    height: 100%;
    display: flex;
    flex: 1;
    padding: 20px;
    margin: 20px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .horario {
      font-size: 1.75rem;
    }
  }
}

@keyframes neon {
  from {
    filter: drop-shadow(0 0 0 var(--cor-neon));
  }

  to {
    filter: drop-shadow(0 0 2px var(--cor-neon));
  }
}
</style>
